// ------------------------------------
// Funções Úteis
// ------------------------------------

// Debounce (Melhora a performance de funções repetitivas como "Scroll / Resize")
const debounce = function (n, t, u) {
  var e;
  return function () {
    var a = this,
      i = arguments,
      o = function () {
        (e = null), u || n.apply(a, i);
      },
      r = u && !e;
    clearTimeout(e), (e = setTimeout(o, t)), r && n.apply(a, i);
  };
};

/* Verifica o tamanho da tela de acordo com o tipo passado 
(Smartphone, Tablet ou Desktop) */
function isMedia(media) {
  /* * * * * * * * * * * * * * * * * * * * *
   *  TIPOS DE TELA                        *
   *  SM = Mobile  (< 768px)               *
   *  MD = Tablet  (>= 768px e < 1280px)   *
   *  LG = Desktop (>= 1280px)             *
   * * * * * * * * * * * * * * * * * * * * */
  media = media.trim().toLowerCase();
  const size = $(window).width();
  const validations = {
    sm: size < 768,
    md: size >= 768 && size < 1280,
    lg: size >= 1280,
  };
  return validations[media];
}

// Copia uma string para a área de transferência
function copyToClipboard(str) {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
}

// Valida CPF
function isValidCPF(r) {
  var t, a, n, e, i;
  if (((i = 1), (r = r.replace(/[^\d]+/g, '')).length != 11)) return !1;
  for (e = 0; e < r.length - 1; e++)
    if (r.charAt(e) != r.charAt(e + 1)) {
      i = 0;
      break;
    }
  if (i) return !1;
  for (t = r.substring(0, 9), a = r.substring(9), n = 0, e = 10; e > 1; e--) n += t.charAt(10 - e) * e;
  if ((n % 11 < 2 ? 0 : 11 - (n % 11)) != a.charAt(0)) return !1;
  for (t = r.substring(0, 10), n = 0, e = 11; e > 1; e--) n += t.charAt(11 - e) * e;
  return (n % 11 < 2 ? 0 : 11 - (n % 11)) == a.charAt(1);
}

// Valida CNPJ
function isValidCNPJ(r) {
  if ('' == (r = r.replace(/[^\d]+/g, ''))) return !1;
  if (14 != r.length) return !1;
  if (
    '00000000000000' == r ||
    '11111111111111' == r ||
    '22222222222222' == r ||
    '33333333333333' == r ||
    '44444444444444' == r ||
    '55555555555555' == r ||
    '66666666666666' == r ||
    '77777777777777' == r ||
    '88888888888888' == r ||
    '99999999999999' == r
  )
    return !1;
  for (var t = r.length - 2, n = r.substring(0, t), a = r.substring(t), e = 0, i = t - 7, u = t; u >= 1; u--)
    (e += n.charAt(t - u) * i--), i < 2 && (i = 9);
  var f = e % 11 < 2 ? 0 : 11 - (e % 11);
  if (f != a.charAt(0)) return !1;
  for (t += 1, n = r.substring(0, t), e = 0, i = t - 7, u = t; u >= 1; u--)
    (e += n.charAt(t - u) * i--), i < 2 && (i = 9);
  return (f = e % 11 < 2 ? 0 : 11 - (e % 11)) == a.charAt(1);
}

// Valida CPF ou CNPJ
function isValidCPForCNPJ(value) {
  return isValidCPF(value) || isValidCNPJ(value);
}

// Valida e-mail
function isValidEmail(email) {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

// Valida telefone
function isValidPhone(tel) {
  return /(\([1-9]{2}\))\s([9]{1})?([0-9]{4})-([0-9]{4})/.test(String(tel).toLowerCase());
}

// Formata um valor para real (R$)
function formatMoneyBR(v, c, d, t) {
  var n = v,
    c = isNaN((c = Math.abs(c))) ? 2 : c,
    d = d == undefined ? ',' : d,
    t = t == undefined ? '.' : t,
    s = n < 0 ? '-' : '',
    i = parseInt((n = Math.abs(+n || 0).toFixed(c))) + '',
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : '')
  );
}

// Formata um valor em real (R$) para o formato do banco
function formatMoneyBD(value) {
  return value.replace('.', '').replace(',', '.');
}

// Formata peso (3 casas decimais)
function formatWeight(value) {
  if (!isNaN(value) && value > 0) {
    return parseFloat(value).toFixed(3).replace('.', ',');
  }
  return 0;
}

// Obtém a largura de um texto em pixels
function measureText(string, fontSize = 14, fontWeight = 400) {
  const $el = $('<div></div>');
  $el.css({
    position: 'absolute',
    top: -1000,
    left: -1000,
    visibility: 'hidden',
    'white-space': 'nowrap',
    'font-size': fontSize,
    'font-weight': fontWeight,
  });
  $el.text(string);
  $('body').append($el);
  const textWidth = $el.width();
  $el.remove();
  return textWidth;
}

// Converte em json
function jsonParser(data) {
  if (typeof data == 'string') {
    try {
      data = JSON.parse(data);
      return jsonParser(data);
    } catch (e) {
      return false;
    }
  } else {
    return data;
  }
}

// Gera um slug
function slugify(text) {
  return text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');
}

// Gera uma string aleatória
function generateString(length = 10) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// Remove tags html de uma string
function stripTags(string) {
  return string.replace(/<(.|\n)*?>/g, '');
}

// Retorna o html com as entities decodificadas
function decodeHtml(html) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

// Executa uma acão quando o elemento estiver visível na tela
function doWhenVisible($el, callback) {
  const $window = $(window);
  const scrollAnimationDebounce = 50;
  let executed = false;
  $window.on(
    'scroll',
    debounce(function () {
      checkVisibility();
    }, scrollAnimationDebounce),
  );
  // Verifica se o elemento está visível na tela
  function checkVisibility() {
    if (isElVisible($el)) {
      if (!executed) {
        callback();
        executed = true;
      }
    } else {
      executed = false;
    }
  }
  checkVisibility();
}

// Verifica se o elemento está visível na tela
function isElVisible($el) {
  const scrollAnimationOffset = 0;
  const $window = $(window);
  const scrollTop = $window.scrollTop();
  const windowHeight = $window.height();
  const eleTop = $el.offset().top;
  return scrollTop + windowHeight > eleTop + scrollAnimationOffset;
}

// Remove emojis da string
function removeEmojis(string) {
  return string.replace(
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g,
    '',
  );
}

// Valida uma data
function isValidDate(date, more18 = false) {
  const dateArr = date.split('/');
  const day = Number(dateArr[0]);
  const month = Number(dateArr[1]);
  const year = Number(dateArr[2]);
  const dateCur = new Date();
  const curYear = dateCur.getFullYear();
  if (year < 1900 || year > 3000) {
    return false;
  }
  if (more18 && year > curYear - 18) {
    return false;
  }
  if (month < 1 || month > 12) {
    return false;
  }
  if (day < 1 || day > 31) {
    return false;
  }
  return true;
}

// Limitar Texto
function limitText(string, limit, ellipsis = true) {
  if (string.length <= limit) {
    return string;
  }
  if (ellipsis) {
    return string.substring(0, limit) + '...';
  }
  return string.substring(0, limit);
}

// Obtém um parâmetro da url
function getUrlParam(param) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(param);
}

// Executa uma função após um script ser carregado
function loadScript(url, callback = null) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  if (script.readyState) {
    // only required for IE <9
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        if (callback !== null) {
          callback();
        }
      }
    };
  } else {
    //Others
    script.onload = function () {
      if (callback !== null) {
        callback();
      }
    };
  }
  script.src = url;
  document.body.appendChild(script);
}

// Remove o que não for número de uma string
function somenteNumeros(string) {
  return string.replace(/\D/g, '');
}

// Valida número do cartão de crédito (Algoritmo de Luhn)
function luhnValidate(value) {
  value = typeof value === 'number' ? value.toString() : value;
  let nCheck = 0;
  if (value && /[0-9-\s]+/.test(value)) {
    value = value.replace(/\D/g, '');
    value.split('').forEach((v, n) => {
      let nDigit = parseInt(v, 10);
      if (!((value.length + n) % 2) && (nDigit *= 2) > 9) {
        nDigit -= 9;
      }
      nCheck += nDigit;
    });
  }
  return nCheck % 10 === 0;
}

// Retorna uma data em um formato específico
function formataDataExt(data, formato = '{d}/{m}/{Y}') {
  let retorno = formato;
  const time = new Date(data);
  if (isNaN(time)) {
    return false;
  }
  const meses = {
    '01': 'Janeiro',
    '02': 'Fevereiro',
    '03': 'Março',
    '04': 'Abril',
    '05': 'Maio',
    '06': 'Junho',
    '07': 'Julho',
    '08': 'Agosto',
    '09': 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro',
  };
  const diasSemana = [
    'Domingo',
    'Segunda-feira',
    'Terça-feira',
    'Quarta-feira',
    'Quinta-feira',
    'Sexta-feira',
    'Sábado',
  ];
  const siglas = {
    // Dia do mês com zero à esquerda
    d: String(time.getDate()).padStart(2, '0'),
    // Dia da semana abreviado (3 letras)
    D: diasSemana[time.getDay()].substr(0, 3),
    // Dia do mês sem zero à esquerda
    j: time.getDate(),
    // Dia da semana completo
    l: diasSemana[time.getDay()],
    // Mês completo
    F: meses[String(time.getMonth() + 1).padStart(2, '0')],
    // Mês com zero à esquerda
    m: String(time.getMonth() + 1).padStart(2, '0'),
    // Mês abreviado (3 letras)
    M: meses[String(time.getMonth() + 1).padStart(2, '0')].substr(0, 3),
    // Ano completo (4 dígitos)
    Y: time.getFullYear(),
    // Ano abreviado (2 dígitos)
    y: String(time.getFullYear()).slice(-2),
    // Horas (Formato 24h)
    H: String(time.getHours()).padStart(2, '0'),
    // Minutos
    i: String(time.getMinutes()).padStart(2, '0'),
    // Segundos
    s: String(time.getSeconds()).padStart(2, '0'),
  };
  for (const sigla in siglas) {
    if (siglas.hasOwnProperty(sigla)) {
      retorno = retorno.replace('{' + sigla + '}', siglas[sigla]);
    }
  }
  return retorno;
}
